import { FeatureFlagName } from '@/interfaces/User.interface';
import { PermissionType } from '../../../../constants/types';

export function canShowNavItem(
  item: { rules?: Array<PermissionType>; feature?: FeatureFlagName },
  hasPermission: (rules: PermissionType[]) => boolean,
  hasFeature: (flag: FeatureFlagName) => boolean
): boolean {
  if (item.feature && !hasFeature(item.feature)) return false;
  if (item.rules && !hasPermission(item.rules)) return false;
  return true;
}
